import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminToursService } from '../shared/service/admin-tours.service';
import { Tours } from '../shared/model/tours';
import { FileUploadService } from '../shared/service/file-upload.service';
import { AutoLogoutService } from '../shared/service/auto-logout.service';
import { CommonService } from '../shared/service/common.service';
const LOCAL_USER_KEY = "UserName";
const STORE_KEY = 'lastAction';
@Component({
  selector: 'app-admin-tours-details',
  templateUrl: './admin-tours-details.component.html',
  styleUrls: ['./admin-tours-details.component.css']
})
export class AdminToursDetailsComponent implements OnInit {
  LocalToken: string = '';
  tourId: number;
  fileListObj: FileList;
  data: Tours = {
    Id: null,
    TourName: null,
    TourType: null,
    BusType: null,
    BusACType: null,
    TourImage: null,
    Destinations: null,
    StartDate: null,
    EndDate: null,
    TourDays: null,
    TourManager: null,
    TourCurrentDest: null,
    TourDeparture: null,
    TourDescription: null,
    TourDates: null,
    TourPrice: null,
    DeleteRow: null,
    avgRating: null,
    TourBusNumber: null,
    IsCancel: null,
    HotelList: null,
    TourSubType: null,
    PDFFile: null,
    FlightPrice: null
  };

  NonACSeatCouple = '';
  ACSeatCouple = '';
  NonACSleeperCouple = '';
  ACSleeperCouple = '';
  NonACSeatPerson = '';
  ACSeatPerson = '';
  NonACSleeperPerson = '';
  ACSleeperPerson = '';
  adult = '';
  childBedSix = '';
  childNoBed = '';
  single = '';
  infant = '';
  Month1 = '';
  Month2 = '';
  Month3 = '';
  Month4 = '';
  Month5 = '';
  Month6 = '';
  Month7 = '';
  Month8 = '';
  TourDates1 = '';
  TourDates1R = '';
  TourDates2 = '';
  TourDates2R = '';
  TourDates3 = '';
  TourDates3R = '';
  TourDates4 = '';
  TourDates4R = '';
  TourDates5 = '';
  TourDates5R = '';
  TourDates6 = '';
  TourDates6R = '';
  TourDates7 = '';
  TourDates7R = '';
  TourDates8 = '';
  TourDates8R = '';

  monthsArr = ["None","January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  toursArr = [];

  constructor(private route: ActivatedRoute, private adminToursService: AdminToursService, private router: Router, private fileUploadService: FileUploadService, private autoLogoutService: AutoLogoutService, private commonService: CommonService) {
    localStorage.setItem(STORE_KEY, Date.now().toString());
    this.autoLogoutService.check();
    this.autoLogoutService.initListener();
    this.autoLogoutService.initInterval();

    this.route.params.subscribe((result) => {
      this.tourId = result.id;
    }, (err) => console.log(err));
  }

  ngOnInit() {
    this.LocalToken = localStorage.getItem(LOCAL_USER_KEY);
    if (this.LocalToken != null) {
      this.getToursById();
    }
    else {
      this.router.navigate(["admin/logIn"]);
    }

  }

  getToursById() {
    this.adminToursService
      .getToursByID(this.tourId)
      .then((result) => {
        console.log(result);
        this.toursArr = result;
        this.data = this.toursArr[0];
        if (this.toursArr.length > 0) {
          let tmpPriceArr = [];
          if (this.toursArr[0].TourPrice) {
            tmpPriceArr = this.toursArr[0].TourPrice.split(',');
            this.NonACSeatCouple = tmpPriceArr[0];
            this.ACSeatCouple = tmpPriceArr[1];
            this.NonACSleeperCouple = tmpPriceArr[2];
            this.ACSleeperCouple = tmpPriceArr[3];
            this.NonACSeatPerson = tmpPriceArr[4];
            this.ACSeatPerson = tmpPriceArr[5];
            this.NonACSleeperPerson = tmpPriceArr[6];
            this.ACSleeperPerson = tmpPriceArr[7];
          }

          let flightPriceArr = [];
          if (this.toursArr[0].FlightPrice) {
            flightPriceArr = this.toursArr[0].FlightPrice.split(',');
            this.adult = flightPriceArr[0];
            this.childBedSix = flightPriceArr[1];
            this.childNoBed = flightPriceArr[2];
            this.single = flightPriceArr[3];
            this.infant = flightPriceArr[4];
          }

          if (this.toursArr[0].TourDates) {
            let tmpDatesArr = this.toursArr[0].TourDates.split(';');
            let tmpDatesArr1 = tmpDatesArr[0].split('=');
            this.Month1 = tmpDatesArr1[0];
            let tmpDatesArr1Child = tmpDatesArr1[1].split("R");
            this.TourDates1 = tmpDatesArr1Child[0];
            this.TourDates1R = tmpDatesArr1Child[1];

            let tmpDatesArr2 = tmpDatesArr[1].split('=');
            this.Month2 = tmpDatesArr2[0];
            let tmpDatesArr2Child = tmpDatesArr2[1].split("R");
            this.TourDates2 = tmpDatesArr2Child[0];
            this.TourDates2R = tmpDatesArr2Child[1];

            let tmpDatesArr3 = tmpDatesArr[2].split('=');
            this.Month3 = tmpDatesArr3[0];
            let tmpDatesArr3Child = tmpDatesArr3[1].split("R");
            this.TourDates3 = tmpDatesArr3Child[0];
            this.TourDates3R = tmpDatesArr3Child[1];

            let tmpDatesArr4 = tmpDatesArr[3].split('=');
            this.Month4 = tmpDatesArr4[0];
            let tmpDatesArr4Child = tmpDatesArr4[1].split("R");
            this.TourDates4 = tmpDatesArr4Child[0];
            this.TourDates4R = tmpDatesArr4Child[1];

            let tmpDatesArr5 = tmpDatesArr[4].split('=');
            this.Month5 = tmpDatesArr5[0];
            let tmpDatesArr5Child = tmpDatesArr5[1].split("R");
            this.TourDates5 = tmpDatesArr5Child[0];
            this.TourDates5R = tmpDatesArr5Child[1];

            let tmpDatesArr6 = tmpDatesArr[5].split('=');
            this.Month6 = tmpDatesArr6[0];
            let tmpDatesArr6Child = tmpDatesArr6[1].split("R");
            this.TourDates6 = tmpDatesArr6Child[0];
            this.TourDates6R = tmpDatesArr6Child[1];

            let tmpDatesArr7 = tmpDatesArr[6].split('=');
            this.Month7 = tmpDatesArr7[0];
            let tmpDatesArr7Child = tmpDatesArr7[1].split("R");
            this.TourDates7 = tmpDatesArr7Child[0];
            this.TourDates7R = tmpDatesArr7Child[1];

            let tmpDatesArr8 = tmpDatesArr[7].split('=');
            this.Month8 = tmpDatesArr8[0];
            let tmpDatesArr8Child = tmpDatesArr8[1].split("R");
            this.TourDates8 = tmpDatesArr8Child[0];
            this.TourDates8R = tmpDatesArr8Child[1];
          }
        }
      })
      .catch((err) => console.log(err));
  }

  updateToursDetails() {
    this.data.Id = this.tourId;
    this.data.TourPrice = this.NonACSeatCouple + "," + this.ACSeatCouple + "," + this.NonACSleeperCouple + "," + this.ACSleeperCouple + "," + this.NonACSeatPerson + "," + this.ACSeatPerson + "," + this.NonACSleeperPerson + "," + this.ACSleeperPerson;
    this.data.FlightPrice = this.adult + "," + this.childBedSix + "," + this.childNoBed + "," + this.single + "," + this.infant;
    this.data.TourDates = this.Month1 + "=" + this.TourDates1 + "R" + this.TourDates1R + ";" + this.Month2 + "=" + this.TourDates2 + "R" + this.TourDates2R + ";" + this.Month3 + "=" + this.TourDates3 + "R" + this.TourDates3R + ";" + this.Month4 + "=" + this.TourDates4 + "R" + this.TourDates4R + ";" + this.Month5 + "=" + this.TourDates5 + "R" + this.TourDates5R + ";" + this.Month6 + "=" + this.TourDates6 + "R" + this.TourDates6R + ";" + this.Month7 + "=" + this.TourDates7 + "R" + this.TourDates7R + ";" + this.Month8 + "=" + this.TourDates8 + "R" + this.TourDates8R + ";";
    console.log(this.data);
    if (this.fileListObj) {
      let folderName = "Tours\\" + this.data.Id;
      this.adminToursService
        .editTours(this.data)
        .then((result) => {
          this.fileUploadService.ImageUpload(this.fileListObj, folderName).then(() => {
            this.router.navigate(["admin/tours"]);
            this.clearControl();
          })
            .catch((err) => this.errorHandler(err));
        })
        .catch((err) => this.errorHandler(err));
    }
    else {
      this.adminToursService
        .editTours(this.data)
        .then((result) => {
          this.router.navigate(["admin/tours"]);
          this.clearControl();
        })
        .catch((err) => this.errorHandler(err));
    }

  }

  public docChoose(fileInput: any, category: string) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.data.PDFFile = "";
      if (category == "TourPDF") {
        this.data.PDFFile = fileInput.target.files[0].name;
      }
    }
  }

  removeFile(event) {
    var itemtoRemove = event.target.outerText;
    console.log(this.data.Id);
    if (itemtoRemove) {
      if (confirm("PDF will deleted permenently. Are you sure?")) {
        this.data.PDFFile = null;
        let parentFolder = "Tours";
        this.commonService
          .FileDelete(this.data.Id, itemtoRemove, parentFolder).then(() => {
            console.log("file delete");
            this.adminToursService
              .editTours(this.data)
              .then((result) => {
                console.log("FileDeleted ", + result);
              })
              .catch((err) => this.errorHandler(err));
          }).catch((err) => this.errorHandler(err));
      }
    }
  }

  fileChange(event, category) {
    this.docChoose(event, category);
    this.fileListObj = event.target.files;
  }

  clearControl() {
    this.data
  }

  errorHandler(err: any) {
    console.log(err);
  }
}